var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWithdrawSucc(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.827 5.227H5v-2.3L.333 6.377 5 9.824v-2.3h3.827a2.297 2.297 0 010 4.594H2.43v2.297h6.398a4.597 4.597 0 004.592-4.596 4.592 4.592 0 00-4.592-4.592z",
    fill: "#C4C4C4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.25 10.592a4.375 4.375 0 118.75 0 4.375 4.375 0 01-8.75 0z",
    fill: "#5FC375"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.25 10.37l1.896 1.896 3.104-3.104",
    stroke: "#fff",
    strokeWidth: 1.2,
    strokeLinejoin: "round"
  })));
}
export default __webpack_public_path__ + "static/withdraw-succ.ed270a72.svg";
export { SvgWithdrawSucc as ReactComponent };